export default __webpack_public_path__ + "static/media/video-3.dd751820.mp4";